import React from 'react';
import SearchForm from './SearchForm';

function SecondTab(props) {
    const { values, checkboxHandleChange, setChartVisibleStyle } = props;
    const isDisplay = values.chartParam.sekkeiKubun === '2';
    return (
        <React.Fragment>
            {isDisplay && (
                <div>
                    <SearchForm values={values} checkboxHandleChange={checkboxHandleChange} setChartVisibleStyle={setChartVisibleStyle} />
                </div>
            )}
        </React.Fragment>
    )
}

export default SecondTab;
